import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAllInquiries } from "./services/inquiry.services";
import { IInquiry, IInquiryState } from "./inquiryModel";

const initialState: IInquiryState = {
  loading: false,
  error: "",
  InquiryList: [],
  FilterInquiry: {
    Name: "",
    MobileNo: "",
    EmailID: "",
    FromDate: "",
    ToDate: "",
    TourName: "",
    SectorName: "",
  },
};

const userMSlice = createSlice({
  name: "inquiry",
  initialState,
  reducers: {
    setFilterInquiry: (state, action) => {
      state.FilterInquiry = action.payload;
    },
    clearFilterInquiry: (state) => {
      state.FilterInquiry = initialState.FilterInquiry;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllInquiries.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getAllInquiries.fulfilled,
      (state, action: PayloadAction<IInquiry[]>) => {
        state.loading = false;
        state.InquiryList = action.payload || [];
        state.error = "";
      }
    );
    builder.addCase(getAllInquiries.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.InquiryList = [];
    });
  },
});
export const { setFilterInquiry, clearFilterInquiry } = userMSlice.actions;
export default userMSlice.reducer;
